import {getPublicProperty} from '@netx/core-app-next/utils/getPublicProperty';
import {UploadPref, UNCHUNKED_MAX_FILE_SIZE_DEFAULT} from '../constants';

/**
 * Get the max file size for unchunked uploads
 * @returns max file size for unchunked uploads
 */
export const getUnchunkedMaxFileSize = () => {
	const prop = getPublicProperty(UploadPref.UNCHUNKED_MAX_FILE_SIZE);
	const chunkSize = prop
		? parseInt(prop) * 1000 * 1000
		: UNCHUNKED_MAX_FILE_SIZE_DEFAULT;
	return chunkSize || UNCHUNKED_MAX_FILE_SIZE_DEFAULT;
};
